import { render, staticRenderFns } from "./GerarDocAssociadoDetalhes.vue?vue&type=template&id=1f9cc3ad"
import script from "./GerarDocAssociadoDetalhes.vue?vue&type=script&lang=js"
export * from "./GerarDocAssociadoDetalhes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports